import { render, staticRenderFns } from "./EmailOptional.vue?vue&type=template&id=7f51a9b4"
import script from "./EmailOptional.vue?vue&type=script&lang=js"
export * from "./EmailOptional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f51a9b4')) {
      api.createRecord('7f51a9b4', component.options)
    } else {
      api.reload('7f51a9b4', component.options)
    }
    module.hot.accept("./EmailOptional.vue?vue&type=template&id=7f51a9b4", function () {
      api.rerender('7f51a9b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/invoices/components/EmailOptional.vue"
export default component.exports